<template>
  <div class="wf-select">
    <el-popover ref="popover" :placement="placement" width="314" trigger="click" v-model="visible" :disabled="readonly" @show="showPanel">
      <div class="search-member" v-loading="loading">
        <div class="search-top">
          <p class="total" v-if="departmentalStructure">
            全部成员
            <span class="num">{{ membersUidArr.length }}</span>
          </p>
          <el-input
            class="top-search"
            prefix-icon="icon iconfont iconicon_search1"
            v-model="keyword"
            size="mini"
            :placeholder="placeholder"
            clearable
            @input="searchInput"
          ></el-input>
        </div>

        <!-- 需要下拉加载的成员列表 -->
        <div
          v-if="!departmentalStructure"
          class="search-content"
          v-loading="loading"
          v-infinite-scroll="loadNext"
          :infinite-scroll-distance="20"
          :infinite-scroll-immediate="false"
        >
          <div class="search-content-item" v-for="(item, i) in dataset" :key="i" @click="checkItem(item)">
            <slot name="item" :data="item"></slot>
            <i
              class="icon iconfont iconicon_selected_more_task"
              v-if="checkShow(item)"
            ></i>
          </div>
          <nothing v-if="!loading && dataset.length == 0" :width="'88px'" :config="{ tip: '暂无数据' }"></nothing>
          <div class="loading-box" v-if="isLoading">
            <i class="el-icon-loading"></i>
          </div>
        </div>

        <!-- 有部门结构的成员列表，结构为 部门：[成员列表] -->
        <div
          v-if="departmentalStructure"
          class="members-con-wrap search-content"
          v-loading="loading"
        >
          <div class="members-con" v-if="!searchData.length && !showNothing">
            <ul
              v-for="(value, key) in dataObj"
              :key="key"
            >
              <p class="tit" v-if="value.length">{{ key }}</p>
              <li v-for="item in value" :key="item.uid" @click="checkItem(item)">
                <slot name="item" :data="item"></slot>
                <i
                  class="icon iconfont iconicon_selected_more_task"
                  v-if="checkShow(item)"
                ></i>
              </li>
            </ul>
          </div>
          <ul v-else>
            <li
              v-for="item in searchData"
              :key="item.uid"
              @click="checkItem(item)"
            >
              <slot name="item" :data="item"></slot>
              <i
                class="icon iconfont iconicon_selected_more_task"
                v-if="checkShow(item)"
              ></i>
            </li>
          </ul>
          <nothing v-if="showNothing" :width="'88px'" :config="{ tip: '暂无此成员' }"></nothing>
        </div>

      </div>
      <template #reference>
        <slot :data="isCheckData"></slot>
      </template>
    </el-popover>
  </div>
</template>

<script>
import api from '@/services/api/staffManagement/staffManagement'

export default {
  name: "WfSelect",
  components: {
  },
  props: {
    value: {
      type: [String, Number, Array],
      default: ''
    },
    placement: {
      type: String,
      default: 'bottom'
    },
    placeholder: {
      type: String,
      default: '搜索项目成员'
    },
    // 有部门结构的成员列表
    departmentalStructure: {
      type: Boolean,
      default: false
    },
    // 成员列表，包含部门结构的
    membersDataList: {
      type: [Array, Object],
      default: () => {
        return {}
      }
    },
    // 成员id组成的数组
    membersUidArr: {
      type: [Array, Object],
      default: () => {
        return []
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    lazy: {
      type: Boolean,
      default: false
    },
    load: {
      type: Function,
      default: (resolve) => {
        resolve([])
      }
    },
    option: {
      type: [Array, Object],
      default: () => {
        return []
      }
    },
    props: {
      type: Object,
      default: () => {
        return {
          value: 'value',
          label: 'label'
        }
      }
    }
  },
  data() {
    return {
      visible: false,
      dataset: [],
      dataObj: {},
      searchData: [],
      showNothing: false,
      loading: false,
      keyword: '',
      page: 1,
      number: 30,
      isFinish: false,
      isLoading: false,
      timer: null
    }
  },
  computed: {
    currentValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    isCheckData() {
      let arr = []
      if (!this.departmentalStructure) {
        arr = this.dataset
      } else {
        arr = [].concat(...Object.values(this.membersDataList))
      }
      if(!this.multiple) {
        return arr.find(res => res[this.props.value] === this.currentValue)
      } else {
        return arr.filter(res => this.currentValue.includes(res[this.props.value]))
      }
    }
  },
  watch: {
    visible(val) {
      this.$emit('handleShowPanel', val)
    }
  },
  mounted() {
    if (this.departmentalStructure) {
      // 有部门结构的引用组件
      this.dataObj = this.membersDataList
    }
  },
  methods: {
    searchInput() {
      this.debounce(() => {
        if (!this.departmentalStructure) {
          this.page = 1
          this.dataset = []
          this.init()
        } else {
          this.searchData = []
          this.handleSearch()
        }
      }, 400)
    },
    //防抖函数
    debounce(fn, wait) {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(fn, wait)
    },
    async init() {
      this.loading = false
      this.isFinish = false
      this.isLoading = false
      this.dataset = []
      if(this.lazy && this.dataset.length === 0) {
        this.loading = true
        let result =  await this.getResolveData()
        this.dataset.push(...result)
        this.loading = false
      }
      this.$nextTick(() => {
        this.$refs.popover.updatePopper()
      })
    },
    async handleSearch() {
      if (this.keyword) {
        this.loading = true
        const param = {
          page: 1,
          number: 999,
          keyword: this.keyword,
          working_type: '在职'
        }
        const res = await api.getStaffIndex(param)
        if (res) {
          this.searchData = res.data
          this.showNothing = this.searchData.length ? false : true
          this.loading = false
        }
        this.$nextTick(() => {
          this.$refs.popover.updatePopper()
        })
      } else {
        // 清空搜索框
        this.searchData = []
        this.showNothing = false
      }

    },
    showPanel() {
      this.keyword = ''
      this.init()
    },
    getResolveData() {
      return new Promise((resolve, reject) => {
        this.load(res => {
          resolve(res)
        }, { page: this.page, number: this.number, keyword: this.keyword })
      })
    },
    async loadNext() {
      if(this.loading || this.isLoading || this.isFinish) return
      this.isLoading = true
      this.page = this.page + 1
      let result = await this.getResolveData()
      this.dataset.push(...result)
      if(!result || result.length === 0) {
        this.isFinish = true
      }
      this.isLoading = false
    },
    checkShow(item) {
      // const _list = this.departmentalStructure ? this.membersUidArr : this.currentValue
      const _list = this.currentValue

      if(!this.multiple) {
          return item[this.props.value] === _list
        } else {
          return _list.includes(item[this.props.value])
        }

    },
    checkItem(item) {
      if(!this.multiple) {
        this.currentValue = item[this.props.value]
        this.$refs.popover.doClose()
      } else {
        let idx = this.currentValue.indexOf(item[this.props.value])
        if(idx > -1) {
          this.currentValue.splice(idx, 1)
        } else {
          this.currentValue.push(item[this.props.value])
        }
      }
      this.$nextTick(() => {
        this.$emit('change', this.isCheckData)
      })
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/scss/mixin.scss";
.search-member {
  width: 100%;
  min-height: 580px;
  max-height: 580px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 24px 0 8px;
  box-sizing: border-box;
  &.show-all {
    // max-height: 728px;
  }
  &.no-content {
    min-height: 276px;
  }
  &.is-comment {
    &.no-content {
      min-height: 580px;
      .nothing-box {
        top: 154px;
      }
    }
  }
  .all-footer {
    display: flex;
    align-items: center;
    margin: 16px 0 0;
    padding: 0 24px;
    box-sizing: border-box;
    font-size: 12px;
    @include fontColorOpacity(.6);
    cursor: pointer;
    height: 20px;
    line-height: 20px;
    text-align: center;
    i {
      font-size: 12px;
      color:#A6A6A6;
      margin-right: 8px;
    }
  }
  .clear-btn {
    padding: 2px 8px;
    margin-left: 5px;
    // background-color: #fff;
    // border-color: #fff;
    // color: initial;
    // &:hover {
    //   color: #509aff;
    // }
  }
  .search-top {
    padding: 0 24px 16px 24px;
    .total {
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      .num {
        font-size: 14px;
        @include fontColorOpacity(.6);
        margin-left: 16px;
      }
    }
    // border-bottom: 1px solid #f1f2f4;
  }
  .search-content-top-iscomment {
    width: 100%;
    padding: 0 24px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    @include fontColorOpacity(.6);
    .num {
      cursor: pointer;
      &:hover {
        color: #2682FF;
      }
      &:active {
        color: #2560B1;
      }
      span {
        margin-left: 8px;
      }
    }
  }
  .colleagues-list {
    padding: 5px;
    display: block;
    margin-left: 0;
  }
  .search-content {
    width: 100%;
    height: 0;
    padding: 0 24px;
    box-sizing: border-box;
    flex: 1;
    overflow: auto;
    overflow: overlay;
    position: relative;
  }
  .loading-box {
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .search-content-item {
    cursor: pointer;
    height: 40px;
    line-height: 40px;
    display: flex;
    justify-content: space-between;
    border-radius: 4px;
    padding: 0 8px;
    &:hover {
      @include bgColorOpacity(.04);
    }
    &:active {
      @include bgColorOpacity(.04)
    }
    .item-content {
      display: flex;
      .el-checkbox {
        padding: 0 15px 0 0;
      }
    }
    i {
      color: $color-active;
    }
  }
  .members-con-wrap {
    ul {
      .tit {
        font-size: 14px;
        line-height: 40px;
        @include fontColorOpacity(.6);
      }
      li {
        width: 100%;
        height: 40px;
        padding: 0 8px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        position: relative;
        &:hover {
          @include bgColorOpacity(.04);
        }
        &:active {
          background: #EAEBEC;
        }
        /deep/ .avatar-box .name-txt {
          margin-left: 16px;
        }
        i {
          color: $color-active;
        }
      }
    }
  }
  .active {
    // @include bgColorOpacity(.04);
    // ::v-deep {
    //   span {
    //     color: #2682ff;
    //   }
    // }
  }

  .search-member-footer {
    width: 100%;
    height: 52px;
    padding: 0 24px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    border-top: 1px solid rgba(32, 32, 32, .08);
    .btn {
      font-size: 14px;
      line-height: 60px;
      padding-left: 8px;
    }
    .wf-button {
      margin-top: 14px;
    }
  }
}
</style>
